import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from '../loja/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EnvironmentsService extends BaseService {
  project_id: any;

  constructor(protected http: Http, private httpClient: HttpClient) {
    super(http, 'api/v2/admin', 'environments')
  }

  // https://apiv3.plataformaasap.com.br/api/v2/admin/notice/orientation/recurso/8645
  getRecurso(project_id) {
    this.basePath = 'api/v2/admin';
    this.entityName = 'notice/orientation/recurso';

    return this.getResource(project_id);
  }

  //api/v2/admin/environments/id/778?projeto=9588&client_id=240

  getProtocolo(environment, id: number, save?: string) {
    this.basePath = 'api/v2/admin';
    this.entityName = `environments/id`;
    let query = `projeto=${id}`

    if (save) {
      query += `&save=${save}`;
    }
    return this.getResource(environment, {
      query,
    });
  }




  // https://apiv3.plataformaasap.com.br/api/v2/admin/environments/id/803?projeto=8861&client_id=240&save=sim
  getEnvironment(environment, id: number, save?: string) {
    this.basePath = 'api/v2/admin';
    this.entityName = 'environments/id';

    let query = `projeto=${id}`;

    if (save) {
      query += `&save=${save}`;
    }

    return this.getResource(environment, {
      query,
    });
  }

  postEnvironment(payload: any, environment: number, id: number) {
    this.basePath = 'api/v2/admin';
    this.entityName = 'environments/id/' + environment;

    let query = `projeto=${id}`;

    return this.createResource(payload, {
      query,
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/services/environments/environments.service.ts